import Konva from "konva";
import React from "react";
import { Text } from "react-konva";

const Label: React.FC<React.PropsWithChildren<Konva.TextConfig>> = (props) => {
  return (
    <Text
      {...props}
      fontSize={10}
      fill="#555"
      align="center"
      verticalAlign="middle"
      height={0}
      width={30}
    />
  );
};

export default Label;
